import { render, staticRenderFns } from "./SemenBatch.vue?vue&type=template&id=39bb4eca&"
import script from "./SemenBatch.vue?vue&type=script&lang=js&"
export * from "./SemenBatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports